const VIEW_PRESETS = {
	perspective: {
		name: "Perspective",
		position: { x: 5, y: 5, z: 5 },
		target: { x: 0, y: 0, z: 0 },
	},
	isometric: {
		name: "Isometric",
		position: { x: 7, y: 7, z: 7 },
		target: { x: 0, y: 0, z: 0 },
	},
	top: {
		name: "Top",
		position: { x: 0, y: 10, z: 0 },
		target: { x: 0, y: 0, z: 0 },
	},
	front: {
		name: "Front",
		position: { x: 0, y: 0, z: 10 },
		target: { x: 0, y: 0, z: 0 },
	},
	right: {
		name: "Right",
		position: { x: 10, y: 0, z: 0 },
		target: { x: 0, y: 0, z: 0 },
	},
};

const DEFAULT_VIEW: keyof typeof VIEW_PRESETS = "perspective";

const BASE_DISTANCE = 5;
const ZOOM_IN_FACTOR = 1.2;
const ZOOM_OUT_FACTOR = 0.8;

export { BASE_DISTANCE, DEFAULT_VIEW, VIEW_PRESETS, ZOOM_IN_FACTOR, ZOOM_OUT_FACTOR };
